//import ModeloRestaurante from '../../models/Restaurante'
import Restaurante from '../Restaurante'

import ModeloRestaurante from '../../models/Restaurante'

type Props = {
  comercios: ModeloRestaurante[]
}

import { Container, List } from './styles'

const ListaRestaurantes = ({ comercios }: Props) => (
  <Container className="container">
    <div>
      <List>
        {comercios.map((comercio) => (
          <li key={comercio.id}>
            <Restaurante
              id={comercio.id}
              tipo={comercio.infos[0]}
              image={comercio.image}
              title={comercio.title}
              number={Number(comercio.number)}
              destacado={false}
              description={comercio.description}
              button={comercio.button}
            />
          </li>
        ))}
      </List>
    </div>
  </Container>
)

export default ListaRestaurantes
